import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('components/common/Home'),
      children: [
        //首页
        {
          path: '/index',
          name: 'index',
          component: () => import('components/page/index/index'),
          meta: {title: '首页', requireAuth: true},
        },
        {
          path: '/haihuiCloud',
          name: 'haihuiCloud',
          component: () => import('components/page/haihuiCloud/index'),
          meta: {title: '海慧生态云', requireAuth: true},
        },
        {
          path: '/customerCase',
          name: 'customerCase',
          component: () => import('components/page/customerCase/index'),
          meta: {title: '成功案例', requireAuth: true}
        },
        {
          path: '/customerCaseDetail',
          name: 'customerCaseDetail',
          component: () => import('components/page/customerCaseDetail/index'),
          meta: {title: '成功案例详情', requireAuth: true},
        },
        {
          path: '/solution',
          name: 'solution',
          component: () => import('components/page/solution/index'),
          meta: {title: '成功案例详情', requireAuth: true},
        },
        {
          path: '/solutionDetail',
          name: 'solutionDetail',
          component: () => import('components/page/solutionDetail/index'),
          meta: {title: '成功案例详情', requireAuth: true},
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: () => import('components/page/aboutUs/index'),
          meta: {title: '关于我们', requireAuth: true},
        },
        {
          path: '/news',
          name: 'news',
          component: () => import('components/page/news/index'),
          meta: {title: '新闻资讯', requireAuth: true},
        },
        {
          path: '/newDetail',
          name: 'newDetail',
          component: () => import('components/page/newDetail/index'),
          meta: {title: '资讯详情', requireAuth: true},
        },
        {
          path: '/staffStyle',
          name: 'staffStyle',
          component: () => import('components/page/staffStyle/index'),
          meta: {title: '员工风采', requireAuth: true},
        },
      ]
    },
    {
      path: '*',
      component: resolve => require(['components/page/error/index.vue'], resolve)
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js